export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/environments/environment.ts